// route - web
const Index = r => require.ensure([], () => r(require('@/web/app-home.vue')), 'route-site');
const Home = r => require.ensure([], () => r(require('@/web/site/home.vue')), 'route-site');
const List = r => require.ensure([], () => r(require('@/web/site/list.vue')), 'route-site');
const ListS = r => require.ensure([], () => r(require('@/web/site/list-signup.vue')), 'route-site');
const Detail = r => require.ensure([], () => r(require('@/web/site/detail.vue')), 'route-site');
const DetailS = r => require.ensure([], () => r(require('@/web/site/detail-signup.vue')), 'route-site');
const OrderS = r => require.ensure([], () => r(require('@/web/site/order-signup.vue')), 'route-site');
// 关于
const About = r => require.ensure([], () => r(require('@/web/site/about.vue')), 'route-site');

// 活动-商铺
const Shop = r => require.ensure([], () => r(require('@/web/shop/shop.vue')), 'route-shop');
const ShopGoods = r => require.ensure([], () => r(require('@/web/shop/goods.vue')), 'route-shop');
const ShopGoodDetail = r => require.ensure([], () => r(require('@/web/shop/goods-detail.vue')), 'route-shop');
const ShopRecommend = r => require.ensure([], () => r(require('@/web/shop/goods-recommend.vue')), 'route-shop');
const ShopGoodsPay = r => require.ensure([], () => r(require('@/web/shop/goods-pay.vue')), 'route-shop');

const ShopUser = r => require.ensure([], () => r(require('@/web/users/user.vue')), 'route-users');
const UserDetail = r => require.ensure([], () => r(require('@/web/users/user-detail.vue')), 'route-users');
const ShopOrder = r => require.ensure([], () => r(require('@/web/users/order.vue')), 'route-users');
const ShopOrder0 = r => require.ensure([], () => r(require('@/web/users/order-0.vue')), 'route-users');
const ShopOrderDetail = r => require.ensure([], () => r(require('@/web/users/order-detail.vue')), 'route-users');
const UserAddress = r => require.ensure([], () => r(require('@/web/users/address.vue')), 'route-users');
const UserAddressEdit = r => require.ensure([], () => r(require('@/web/users/address-edit.vue')), 'route-users');

// 活动
const Activity = r => require.ensure([], () => r(require('@/web/activity/activity.vue')), 'route-site-activity');
const ActivitySignup = r => require.ensure([], () => r(require('@/web/activity/signup.vue')), 'route-site-activity');
const ActivityLookup = r => require.ensure([], () => r(require('@/web/activity/lookup.vue')), 'route-site-activity');

// 科普
const Kp = r => require.ensure([], () => r(require('@/web/site/kp.vue')), 'route-site-kp');
const KpList = r => require.ensure([], () => r(require('@/web/site/kp-list.vue')), 'route-site-kp');
const KpDetail = r => require.ensure([], () => r(require('@/web/site/kp-detail.vue')), 'route-site-kp');
const KpOrder = r => require.ensure([], () => r(require('@/web/site/kp-order.vue')), 'route-site-kp');

// 意见反馈
const Question = r => require.ensure([], () => r(require('@/web/site/question.vue')), 'route-site-question');

const NotFound = r => require.ensure([], () => r(require('@/web/notfound.vue')), 'route-site-other');

export const webRoute = {
  home: {
    path: '/',
    component: Index,
    props: (route) => ({ token: route.query.t }),
    children: [
      {path:'', component:Home},
    ]
  },
  sites: [
    {path:'/list/:id', component:List, name:'site-list', props:true},
    {path:'/list-s/:id', component:ListS, name:'site-list-s', props:true},
    {path:'/detail/:id', component:Detail, name:'site-view', props:true},
    {path:'/detail-s/:id', component:DetailS, name:'site-view-s', props:(route) => { return {id:route.params.id, back:route.params.back, skus:route.query.skus} }},
    {path:'/order-s/:id', component: OrderS, name:'site-order-s', props:true },
    {path:'/about', component:About, name:'site-about'},
  ],
  shop: [
    {
      path: '/shop',
      component: Shop,
      props: (route) => ({ token: route.query.t }),
      children: [
        {path: '', component: ShopGoods, name:'mall-shop', props:true },
        // {path: 'recommend', component: ShopRecommend, name:'shop-goods-recommend'},
      ]
    },
    {path: '/good/:id', component: ShopGoodDetail, name:'shop-goods-detail', props:(route) => { return {id:route.params.id, skus:route.query.skus} } },
    {path: '/goods-pay', component: ShopGoodsPay, name:'goods-pay', props:true},
    {path: '/user', component:ShopUser, name:'shop-user'},
    {path: '/user/detail', component:UserDetail},
    {path: '/user/address', component:UserAddress, name:'user-address', props:true},
    {path: '/user/address-edit', component:UserAddressEdit, name:'user-address-edit', props:true},
    {path: '/orders', component: ShopOrder, name:'shop-orders',
      children: [
        {path: ':type?', component:ShopOrder0, name:'shop-order-t', props:true}
      ]
    },
    {path: '/order/:id', component: ShopOrderDetail, name:'shop-order-detail', props:true},
  ],
  activity: [
    {path: '/activity', component: Activity, name:'site-activity' },
    {path: '/activity/signup', component: ActivitySignup, name:'site-activity-signup' },
    {path: '/activity/lookup', component: ActivityLookup, name:'site-activity-lookup' },
  ],
  kp: [
    {path: '/kp', component: Kp, name:'site-kp' },
    // {path: '/book/detail/:id', component: Kp, name:'site-kp' },
    {path: '/kp/:navname', component: KpList, name:'site-kp-list', props:true },
    {path: '/kp/detail/:id', component: KpDetail, name:'site-kp-detail', props:(route) => { return {id:route.params.id, back:route.params.back, skus:route.query.skus} } },
    {path: '/kp/order/:id', component: KpOrder, name:'site-kp-order', props:true },
  ],
  quesiton: [
    {path: '/question', component: Question}
  ],
  other: [
    {path:'/*', component: NotFound},
  ]
}